import { useEffect, useRef } from 'react'
import { useSessionStore, useUIStore } from '@/stores'
import { isEmbedded, postMessageToParent } from '@utils/iframe'

export function useIframeCommunication() {
  // Retention lite events — notify parent when session completes or hits a critical error
  const isComplete = useSessionStore(s => s.isSessionComplete)()
  const criticalError = useUIStore(s => s.criticalError)
  const prevCompleteRef = useRef(isComplete)
  const prevErrorRef = useRef(criticalError)

  useEffect(() => {
    if (!isEmbedded()) {
      return
    }
    if (isComplete && !prevCompleteRef.current) {
      postMessageToParent({ type: 'solvpath_lite_close' })
    }
    prevCompleteRef.current = isComplete
  }, [isComplete])

  useEffect(() => {
    if (!isEmbedded()) {
      return
    }
    if (criticalError && !prevErrorRef.current) {
      postMessageToParent({ type: 'solvpath_lite_error' })
    }
    prevErrorRef.current = criticalError
  }, [criticalError])
}
